import {
  Box,
  Button,
  Flex,
  Select,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useToast,
} from '@chakra-ui/react'
import Header from '../../../components/Header'
import { HeadingPages } from '../../../components/HeadingPages'
import { useQuery, QueryErrorResetBoundary, useMutation } from 'react-query'
import { ErrorBoundary } from 'react-error-boundary'
import { Layout } from '../../../components/Layout'
import { api } from '../../../services/api'
import { useForm } from 'react-hook-form'
import { Loader } from '../../../components/ComponentLoader/Loader'
import { format } from 'date-fns'
import { capitalize } from '../../../utils/capitalize'
import { user } from '../../../helpers/user'
import { useEffect } from 'react'

export function PedidosAntecipados() {
  const toast = useToast({
    position: 'top-right',
    duration: 5000,
    isClosable: true,
  })

  const codVend = user?.codigo_vendedor

  const { handleSubmit, register } = useForm()

  const { data: vendedores, isLoading: isLoadingVendedores } = useQuery({
    queryFn: async () => {
      const response = await api.get('/site/v2/editar-pedido/listar-vendedores')

      return response.data.map((vendedor) => {
        return {
          ...vendedor,
          apelido: vendedor.apelido
            .toLowerCase()
            .replace(/\b(\w)/g, (s) => s.toUpperCase()),
        }
      })
    },
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 10, // 10 minutes
    onError: (error) => {
      toast({
        title: 'Erro ao carregar os vendedores',
        description:
          'Não foi possível carregar os vendedores, tente novamente mais tarde.',
        status: 'error',
      })
      console.log(error)
    },
  })

  console.log(vendedores)

  const {
    mutateAsync,
    data: listPedidosAntecipados,
    isLoading,
  } = useMutation({
    mutationFn: async (codvend) => {
      const response = await api.post(
        `/site/v2/crm-controle/listar-pedidos-antecipados`,
        {
          codigo_vendedor: codvend,
        }
      )

      return response.data.map((pedido) => {
        return {
          ...pedido,
          data_despache: pedido.data_despache
            ? format(new Date(pedido.data_despache), 'dd/MM/yyyy')
            : '',
          data_entregue: pedido.data_entregue
            ? format(new Date(pedido.data_entregue), 'dd/MM/yyyy')
            : '',
          data_limite: pedido.data_limite
            ? format(new Date(pedido.data_limite), 'dd/MM/yyyy')
            : '',
          nome_vendedor: capitalize(pedido.nome_vendedor),
          nome_parceiro: capitalize(pedido.nome_parceiro),
          nome_transportadora: capitalize(pedido.nome_transportadora),
          descricao_produto: capitalize(pedido.descricao_produto),
        }
      })
    },
    onError: (error) => {
      toast({
        title: 'Erro ao carregar os pedidos antecipados',
        description:
          'Não foi possível carregar os pedidos antecipados, tente novamente mais tarde.',
        status: 'error',
      })
      console.log(error)
    },
    onSuccess: (data) => {
      console.log(data)
      toast({
        title: 'Sucesso!',
        description: 'Pedidos antecipados carregados com sucesso.',
        status: 'success',
      })
    },
  })

  async function handleListPedidosAntecipados(codvend) {
    try {
      await mutateAsync(codvend)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (codVend) {
      handleListPedidosAntecipados(codVend)
    }
  }, [codVend])

  return (
    <>
      <HeadingPages name="Pedidos Antecipados" />

      <Layout>
        <Flex
          alignItems="start"
          gap={2}
          maxW="560px"
          w="full"
          mx="auto"
          as="form"
          onSubmit={handleSubmit((data) =>
            handleListPedidosAntecipados(data.codvend)
          )}
        >
          <Select
            placeholder="Selecione o Vendedor"
            defaultValue={String(codVend)}
          >
            {isLoadingVendedores ? (
              <option value="">Carregando...</option>
            ) : (
              <>
                <option value="">Selecione o Vendedor</option>
                {vendedores.map((vendedor) => (
                  <option key={vendedor.codvend} value={vendedor.codvend}>
                    {vendedor.apelido}
                  </option>
                ))}
              </>
            )}
          </Select>
          <Button colorScheme="blue" type="submit">
            Buscar
          </Button>
        </Flex>

        <QueryErrorResetBoundary>
          {({ reset }) => (
            <ErrorBoundary
              onReset={reset}
              fallbackRender={({ resetErrorBoundary }) => (
                <Flex
                  alignItems="center"
                  justifyContent="center"
                  h="100vh"
                  flexDirection="column"
                  gap={2}
                >
                  <HeadingPages name="Erro ao carregar os pedidos antecipados" />
                  <Button onClick={() => resetErrorBoundary()}>
                    Tentar novamente
                  </Button>
                </Flex>
              )}
            >
              <Box mt="2rem">
                {isLoading ? (
                  <Loader />
                ) : (
                  <TableContainer>
                    <Table variant="simple">
                      <Thead>
                        <Tr>
                          <Th>Pedido</Th>
                          <Th>Cod parc</Th>
                          <Th>Cod prod</Th>
                          <Th>Quantidade</Th>
                          <Th>Data despacho</Th>
                          <Th>Data entrega</Th>
                          <Th>Prazo entrega</Th>
                          <Th>Data limite</Th>
                          <Th>Produto</Th>
                          <Th>Vendedor</Th>
                          <Th>Parceiro</Th>
                          <Th>Transportadora</Th>
                          <Th>Diferença dias</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {listPedidosAntecipados?.map((pedido, index) => (
                          <Tr key={index}>
                            <Td>{pedido.numero_pedido}</Td>
                            <Td>{pedido.codigo_parceiro}</Td>
                            <Td>{pedido.codigo_produto}</Td>
                            <Td>{pedido.codigo_vendedor}</Td>
                            <Td>{pedido.data_despache}</Td>
                            <Td>{pedido.data_entregue}</Td>
                            <Td>{pedido.data_limite}</Td>
                            <Td>{pedido.prazo_entrega}</Td>
                            <Td>{pedido.descricao_produto}</Td>
                            <Td>{pedido.nome_vendedor}</Td>
                            <Td>{pedido.nome_parceiro}</Td>
                            <Td>{pedido.nome_transportadora}</Td>
                            <Td textAlign="center">{pedido.diferenca_dias}</Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  </TableContainer>
                )}
              </Box>
            </ErrorBoundary>
          )}
        </QueryErrorResetBoundary>
      </Layout>
    </>
  )
}
